import { Theme } from '@mui/material/styles';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { settingsRoutes } from '../../../routes';
import { useUserPhoneSettings } from '../../../sic-lib/api/hooks/useUser';
import AxiosErrorAlert from '../../Shared/Alerts/AxiosErrorAlert';
import Loader from '../../Shared/Loader';
import { PhoneSettingsForm } from './PhoneSettingsForm';

export function PhoneSettings() {
    const { classes } = useStyles();
    const history = useHistory();

    const { data: phoneSettings, isLoading, isError, error } = useUserPhoneSettings();

    useEffect(() => {
        if (!isLoading && !phoneSettings && !isError) {
            history.push(settingsRoutes.changeSicNumber);
        }
    }, [isLoading, phoneSettings, history, isError]);

    return (
        <Loader isLoading={isLoading}>
            {phoneSettings && <PhoneSettingsForm phoneSettings={phoneSettings} />}
            {isError && <AxiosErrorAlert error={error} />}
        </Loader>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
